import MicroMediaSubPage from 'components/MapoAdministration/components/Content-Management/MicroMediaSubPage';

const ScreenMicroMediaSubPage = () => <MicroMediaSubPage />;

export default ScreenMicroMediaSubPage;
